import { Grid } from '@mui/material'
import { AuthLayout } from 'components'
import { WELCOME_DESCRIPTION, WELCOME_SUB_DESCRIPTION, WELCOME_TITLE } from 'config'
import { AuthTitle } from 'containers/Pay'
import { AuthMain, AuthWrapper } from '../SignIn'
import { Form } from './component'

export const ForgotPassword: React.FC = () => {
  return (
    <AuthLayout
      title={WELCOME_TITLE}
      desc={WELCOME_DESCRIPTION}
      isAuthPage={true}
      subDesc={WELCOME_SUB_DESCRIPTION}
    >
      <AuthWrapper isAuthPage={true}>
        <Grid mb={5} container justifyContent={'center'}>
          <Grid item xs={12} md={6}>
            <AuthMain isRounded={true}>
              <AuthTitle title="Reset Password" />
              <Form />
            </AuthMain>
          </Grid>
        </Grid>
      </AuthWrapper>
    </AuthLayout>
  )
}
